export default "__VITE_ASSET__DnSUC1U___"